import localforage from "localforage";

localforage.config({
  name: "BookingDocumentsDB",
  storeName: "documentsStore",
});

export const saveDocumentsToDB = async (data) => {
  try {
    await localforage.setItem("documents", data);
    console.log("Documents saved to IndexedDB");
  } catch (err) {
    console.error("Error saving documents to IndexedDB:", err);
  }
};

export const loadDocumentsFromDB = async () => {
  try {
    const stored = await localforage.getItem("documents");
    return stored || null;
  } catch (err) {
    console.error("Error loading documents from IndexedDB:", err);
    return null;
  }
};

export const clearDocumentsDB = async () => {
  try {
    await localforage.removeItem("documents");
    console.log("IndexedDB cleaned");
  } catch (err) {
    console.error("Error clearing IndexedDB:", err);
  }
};
